/**
 * Single place for auth persistence keys. Access token is stored as a plain
 * string in localStorage (reliable on refresh) and mirrored to a cookie for
 * compatibility / legacy readers.
 */
export const AUTH_LS_KEYS = {
  ACCESS_TOKEN: "ucm_access_token",
  COOP_PROFILE: "coop_details_profile",
  COMPANY_ID: "company_id",
  USER_PROFILE: "user_details_profile",
  USER_TYPE: "user_type",
  ENUMS: "enums",
};

export const AUTH_COOKIE_KEYS = {
  ACCESS_TOKEN: "access_token",
};

export function getAccessTokenCookieOptions() {
  return {
    path: "/",
    sameSite: "lax",
    secure:
      typeof window !== "undefined" &&
      window.location.protocol === "https:",
  };
}
